export default __webpack_public_path__ + "static/BanImg4-c9e9dae7168aa0e1dc8e8697f50319e0.webp";